<template>
    <header>
        <div class="sticky-old">
            <div>
                <span v-show="!onSearch">
                    <div class="flex flex-row items-baseline">
                      <heading :title="title"></heading>

                      <div class="actions mt-2 ml-auto text-lg">
                          <a href="#" v-show="hasSearch" @click.prevent="showSearch()">
                              <i class="fa fa-search" aria-hidden="true"></i>
                          </a>
                          <a v-if="canCreate" href="#" :class='{ "hidden-desktop": onNewPage }' @click.prevent="showCreateItem()">
                              <i class="fa fa-plus" aria-hidden="true"></i>
                          </a>
                      </div>
                    </div>
                </span>
              <span v-show="onSearch" class="flex flex-row">
                    <input type="text" ref="query" v-model="query"/>
                    <div class="actions ml-auto mt-2 mr-1">
                        <a href="#" @click.prevent="hideSearch()" class="close-search text-xl">
                            <i class="fa fa-times" aria-hidden="true"></i>
                        </a>
                    </div>
                </span>
            </div>
          <div v-if="hasFilters" class="nav-filter-bar">
            <a v-for="(filter,key) in filterables" :class="{ active: activeFilter == key }" href="#"
               @click.prevent="triggerFilter(key)">{{ filter }}</a>
          </div>
        </div>
        <div class="buffer" :class='{ "filters-enabled": hasFilters }'></div>
    </header>
</template>

<script>
    export default {
      props: ['title', 'searchable', 'disableCreate', 'filterables','active-filter'],
      data() {
        return {
          onNewPage: true,
          onSearch: false,
          query: ''
        }
      },
      watch: {
        query(query) {
          eventBus.$emit('crud-search-query-changed-' + this.name, query);
        }
      },
      computed: {
        hasFilters() {
          return !_.isEmpty(this.filterables);
        },
        hasSearch() {
          return this.searchable === "true";
        },
        canCreate() {
          return !this.disableCreate;
        },
        name() {
          return this.$parent.name;
        }
      },
      methods: {
        showCreateItem() {
          this.onNewPage = true;
          eventBus.$emit('crud-show-new-' + this.name);
        },
        showSearch() {
          var that = this;
          this.onSearch = true;
          eventBus.$emit('crud-search-shown-' + this.name);
          window.setTimeout(function () {
            that.$refs.query.focus();
          }, 50);
        },
        hideSearch() {
          this.query = '';
          this.onSearch = false;
          eventBus.$emit('crud-search-hidden-' + this.name);
        },
        triggerFilter(key) {
          if (this.activeFilter == key) {
            this.activeFilter = null;
            eventBus.$emit('crud-filter-activated-' + this.name, null);
          } else {
            this.activeFilter = key;
            eventBus.$emit('crud-filter-activated-' + this.name, key);
          }
        }
      },
      mounted() {
        var that = this;

        window.eventBus.$on('crud-show-new-' + this.name, function () {
          that.onNewPage = true;
        });

        window.eventBus.$on('crud-new-item-' + this.name, function () {
          that.onNewPage = true;
        });

        window.eventBus.$on('crud-hide-new-' + this.name, function () {
          that.onNewPage = false;
        });
      }
    }
</script>

<style lang="scss">
header {
  position: relative;
  @include clearfix();
}

.nav-filter-bar {
  margin-bottom: 1em;

  a {
    display: inline-block;
    background-color: #F3F3F3;
    color: #999;
    border-radius: 0.3em;
    text-decoration: none;
    padding: 0.5em 1em;
    font-size: 0.85em;
    margin-right: 1em;

    &.active{
      background-color: $brand;
      color: #FFF;
    }

    &:last-of-type {
      margin-right: 0;
    }
  }
}

div.sticky-old {
  position: absolute;
  width: 100%;
  z-index: 2;

  input {
    width: 85%;
    padding: 0.3em;
    float: left;
  }
}

div.buffer {
  height: 40px;
  position: relative;
  z-index: 1;
  &.filters-enabled{
    height:100px;
  }
}

.actions {
  float: right;

  a {
    float: none !important;
    display: inline-block;
    margin-right: 5px;

    &:last-of-type {
      margin-right: 0;
    }
  }
}

    .close-search{
        margin-top:3px;
    }
</style>
